export default __webpack_public_path__ + "static/media/angela.871788f7.png";